var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocation5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29,
    height: 32,
    viewBox: "0 0 29 32",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.14288 25.1455L6.72855 29.8001C7.55011 30.4849 8.58569 30.8598 9.65511 30.8598H24.3811C25.4329 30.8598 26.2857 30.007 26.2857 28.9551C26.2857 26.8511 24.5801 25.1455 22.4762 25.1455H12.2384M8.00003 22.8598L9.71431 24.5741C10.6611 25.5208 12.1961 25.5208 13.1429 24.5741C14.0896 23.6273 14.0896 22.0923 13.1429 21.1455L10.4818 18.4845C9.62451 17.6271 8.46176 17.1455 7.24933 17.1455H1.14288M24.8493 3.3226H26.6493C26.9676 3.3226 27.2728 3.46307 27.4979 3.71312C27.7229 3.96317 27.8493 4.30231 27.8493 4.65593V17.9893C27.8493 18.3429 27.7229 18.682 27.4979 18.9321C27.2728 19.1821 26.9676 19.3226 26.6493 19.3226H17.0493C16.7311 19.3226 16.4259 19.1821 16.2008 18.9321C15.9758 18.682 15.8493 18.3429 15.8493 17.9893V4.65593C15.8493 4.30231 15.9758 3.96317 16.2008 3.71312C16.4259 3.46307 16.7311 3.3226 17.0493 3.3226H18.8493M24.8493 3.3226C24.8493 2.58622 24.3121 1.98926 23.6493 1.98926H20.0493C19.3866 1.98926 18.8493 2.58622 18.8493 3.3226M24.8493 3.3226L24.8493 3.98926C24.8493 4.72564 24.3121 5.32259 23.6493 5.32259H20.0493C19.3866 5.32259 18.8493 4.72564 18.8493 3.98926L18.8493 3.3226M18.8493 8.65593H24.8493M18.8493 11.9892H24.8493M18.8493 15.3226H24.8493",
    stroke: "#AA1A5F",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation5);
export default __webpack_public_path__ + "static/media/location5.896725b220383823d0cd04e942729e83.svg";
export { ForwardRef as ReactComponent };